import { render } from "./Header.vue?vue&type=template&id=5849029b"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/y6zFeJMc/0/softbot/muaysod/Player/frontEnd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__